import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { useAxios } from "@/composables/api.js";
import { catchError } from "@/composables/error.js";
import { useAppStore } from "@/stores/app.js";

export const useSpaceStore = defineStore("space", () => {
  const appStore = useAppStore();

  const spaces = ref([]);

  const currentSpace = computed(() => {
    if (!appStore.currentRoute.params.spaceId) return null;

    return spaces.value.find(
      (space) => space.workspace_id === appStore.currentRoute.params.spaceId
    );
  });

  const companySpaces = computed(() => {
    if (!appStore.currentRoute.params.companyId) return null;

    return spaces.value.filter(
      (space) => space.company_id === appStore.currentRoute.params.companyId
    );
  });

  async function getSpace(companyId, workspaceId) {
    try {
      const { data } = await useAxios.get(
        `/companies/${companyId}/workspaces/${workspaceId}`
      );

      const spaceIndex = spaces.value.find(
        (spaceObj) => spaceObj.workspace_id === data.workspace.workspace_id
      );

      if (!spaceIndex) spaces.value.push(data.workspace);

      return data.workspaces;
    } catch (error) {
      return catchError(error);
    }
  }

  async function getSpaces(companyId) {
    try {
      const { data } = await useAxios.get(`/companies/${companyId}/workspaces`);

      data.workspaces.forEach((space) => {
        const alreadyIn = spaces.value.find(
          (spaceObj) => spaceObj.workspace_id === space.workspace_id
        );

        if (!alreadyIn) spaces.value.push(space);
      });

      return data.workspaces;
    } catch (error) {
      return catchError(error);
    }
  }

  async function createSpace(spaceObj, companyId) {
    try {
      const { data } = await useAxios.post(
        `/companies/${companyId}/workspaces`,
        spaceObj
      );

      spaces.value = [...spaces.value, data.workspace];

      return data;
    } catch (error) {
      return catchError(error);
    }
  }

  async function updateSpace(spaceObj, company_id, workspace_id) {
    try {
      const { data } = await useAxios.put(
        `/companies/${company_id}/workspaces/${workspace_id}`,
        {
          name: spaceObj.name,
          image_id: spaceObj.image_id,
        }
      );

      const spaceIndex = spaces.value.findIndex(
        (space) => space.workspace_id === workspace_id
      );

      spaces.value[spaceIndex] = data.workspace;

      return data;
    } catch (error) {
      return catchError(error);
    }
  }

  function clear() {
    spaces.value = [];
  }

  return {
    companySpaces,
    currentSpace,
    spaces,
    createSpace,
    getSpace,
    getSpaces,
    updateSpace,
    clear,
  };
});
